<template>
  <div>
    <!-- 运行里程统计 -->
    <!-- 查询 -->
    <div>
      <quickQuery :isMounted="true" @handleQuery="handleQuery" @quickQuery="quickQuery" @download="download" :downloading="downloading" style="text-align: right"/>
    </div>
    <!-- 表格 有合计-->
    <div class="page_container">
      <el-table id="table_MS" 
        :data="dataList" 
        border 
        :size="size" 
        :cell-style="cellStyle"
        v-loading="loading"
      >
        <!-- :show-summary="showSum" 
        :summary-method="getSummaries" -->
        <el-table-column :label="$t('runState.carNo')" align="center" prop="carNo"></el-table-column>
        <el-table-column :label="$t('runState.speed') + '>=120 (km)'" align="center"  prop="highWayMileage"></el-table-column>
        <el-table-column :label="'100<=' + $t('runState.speed') + '<=119 (km)'" align="center"  prop="countryMileage"></el-table-column>
        <el-table-column :label="'80<=' + $t('runState.speed') + '<=99 (km)'" align="center"  prop="provinceMileage"></el-table-column>
        <el-table-column :label="$t('runState.speed') + '<=79 (km)'" align="center"  prop="otherMileage"></el-table-column>
        <el-table-column :label="$t('runState.runMileage')" align="center"  prop="runMileage"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <kl-pagination :total="total" @current-change="currentchange" :pageSize="pageSize" @size-change="sizeChange"></kl-pagination>
    </div>
  </div>
</template>
<script>
import quickQuery from '../components/generalOrQuickQuery.vue'
import { mapState } from "vuex";
import language from '@/utils/getLanguageId'
export default {
  props:{
    size:{
      type: String,
    },
    isClicked:{
      type: Boolean,
      default:false,
    }
  },
  components:{quickQuery},
  data(){
    return{
      downloading:false,
      vehicles:"",
      form:undefined,
      showSum:true,
      dataList:[],
      pageSize:10,
      total:0,
      currentPage:1,
      loading:false,
      LanguageId:1,
    }
  },
  computed:{
    ...mapState({
        operator: (state) => state.user.operator,
        selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
    list(){
      if(this.dataList != null && this.dataList.length > 0){
        return this.dataList.slice((this.currentPage - 1) * this.pageSize,this.currentPage * this.pageSize)
      }
      return [];
    },
  },
  watch:{
    total(newVal){
      this.showSum = newVal > 1 ? true : false;
    },
    // tabs点击才进行初次加载
    isClicked(newVal){
      if(newVal){
        this.getList();
      }
    }
  },
  methods:{
    getSelectedVehicles(){
      this.vehicles = "";
      for(let k = 0; k < this.selectedVehicles.length; k++){
        if(this.selectedVehicles[k].treeLevel == 5){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0,this.vehicles.length-1);
    },
    fixed2(val){
      if(val == 0 || val == null || val == undefined || val == ""){
        return 0;
      }
      if(Number.isInteger(val)) return val;
      return val.toFixed(2)
    },
    sizeChange(val){
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    currentchange(page){
      this.currentPage = page;
      this.getList();
    },
    // 给单元格添加背景色
    cellStyle({row,columnIndex}){
      if(columnIndex == 0){
        return 'background:rgb(238, 244, 255)'
      }
    },
    getList(){
      this.loading = true;
      this.$api.runStateMileageInfo({
        vehicles: this.vehicles,
        beginDate: this.form.beginDate,
        endDate: this.form.endDate,
        OperatorID: this.operator.OperatorId + "",
        PageNo: this.currentPage,
        PageSize: this.pageSize,
        IsExport: 0, // 0是查询 1是下载
        Language: this.LanguageId,
      })
      .then((res)=>{
        if(res && res.code == 200){
          this.dataList = res.data;
          this.total = res.count;
          this.loading = false;
        }
      })
      .catch((e)=>{
          this.loading = false;
          this.dataList = [];
          this.total = 0;
      })
    },
    // 合计行计算
    getSummaries(param){
      let data = this.dataList;
      // console.log(param);
      setTimeout(() => {
        const tds = document.querySelectorAll('#table_MS .el-table__footer-wrapper tr>td');//表格没有固定列时 写法
        // console.log(tds);
        if(tds.length > 0){
          tds[0].colSpan = 1;
          tds[0].style.background = '#E8F0FF';
          // tds[1].style.display = 'none';
          // tds[1].style.background = '#E8F0FF';
        }
      },0)

      const { columns} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t("runState.tableSum");
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        sums[index] = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
        if(!Number.isInteger(sums[index])){
          sums[index] = sums[index].toFixed(2);
        }
      });

      return sums;
    },
    quickQuery(form){
      this.form = form;
      this.currentPage = 1;
      this.vehicles = this.getSelectedVehicles();
      if(this.form.beginDate == "" || this.form.beginDate == null || this.form.beginDate == undefined){
        this.$message({
          message: this.$t("runState.select_search_date"),//'请选择查询时间',
          type: 'warning'
        });
        return ;
      }
      this.getList();
    },
    handleQuery(form){
      this.form = form;
      this.currentPage = 1;
      this.vehicles = this.getSelectedVehicles();
      if(this.form.beginDate == "" || this.form.beginDate == null || this.form.beginDate == undefined){
        this.$message({
          message: this.$t("runState.select_search_date"),//'请选择查询时间',
          type: 'warning'
        });
        return ;
      }
      if(this.isClicked){
        this.getList();
      }
    },
    download(){
      
      this.vehicles = this.getSelectedVehicles();
      var that = this;
      that.downloading = true;
      this.$api.downRunStateMileageInfo({
        vehicles: this.vehicles,
        beginDate: this.form.beginDate,
        endDate: this.form.endDate,
        OperatorID: this.operator.OperatorId + "",
        IsExport: 1, // 0是查询 1是下载
        Language: this.LanguageId,
      })
        .then((res) => {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码
          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.setAttribute(
            "download",
            that.$t("runState.mileageSta")+that.$t("public.download") + `_${that.timestampToTime(new Date().getTime())}.xlsx`
          ); // 表名，自定义
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          that.downloading = false;
        })
        .catch((error) => {
          console.error("下载失败", error);
          that.downloading = false;
        });
    },
    //时间戳转换为日期格式
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
      var Y = date.getFullYear();
      var M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var D = date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        
          return v[j]
      }))
    },
    getSelectedVehicles(){
      this.vehicles = "";
      for(let k = 0; k < this.selectedVehicles.length; k++){
        if(this.selectedVehicles[k].treeLevel == 5){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0,this.vehicles.length-1);
    },
  },
  mounted(){
    this.dataList = [];
    this.total = this.dataList.length;
    this.LanguageId = language(this.$store.getters.locale)
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-table__footer-wrapper tbody td.el-table__cell {
	background: #f5f9ff;
}
</style>